import warningIcon from "../../../assets/warning.svg";
import { formatAmount } from "../utils/formatAmount";
import { AttestationChainId } from "../utils/constants";
import { getChainById, stringToBlobUrl } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BalanceDisplay = _ref => {
  let {
    balance,
    notEnoughFunds
  } = _ref;
  const chain = getChainById(AttestationChainId);
  return /*#__PURE__*/_jsx("div", {
    className: "w-full flex flex-wrap border rounded-lg p-3 my-auto",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/_jsx("img", {
        src: stringToBlobUrl(chain.icon),
        alt: "Ethereum",
        className: "h-8 w-8"
      }), /*#__PURE__*/_jsxs("div", {
        className: "ml-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: "text-lg font-bold",
          children: chain.prettyName
        }), /*#__PURE__*/_jsx("div", {
          className: "text-sm font-mono",
          children: notEnoughFunds ? /*#__PURE__*/_jsxs("div", {
            className: "flex items-center text-red-500",
            children: [/*#__PURE__*/_jsx("img", {
              src: warningIcon,
              alt: "errorIcon",
              className: "h-4 w-4 mr-2"
            }), /*#__PURE__*/_jsxs("span", {
              children: ["Balance: ", formatAmount(balance, 3), " ETH"]
            })]
          }) : /*#__PURE__*/_jsxs("span", {
            children: ["Balance: ", formatAmount(balance, 3), " ETH"]
          })
        })]
      })]
    })
  });
};